import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

export interface AmountRange {
  amountFrom?: number | null;
  amountTo?: number | null;
}

@Component({
  selector: 'que-amount-range-filter',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateDirective, TranslatePipe],
  templateUrl: './amount-range-filter.component.html',
  styleUrls: ['./amount-range-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: AmountRangeFilterComponent, multi: true }]
})
export class AmountRangeFilterComponent {
  fromControl = new FormControl<number | null>(null);
  toControl = new FormControl<number | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: AmountRange | null): void {
    this.fromControl.setValue(obj?.amountFrom ?? null, { emitEvent: false });
    this.toControl.setValue(obj?.amountTo ?? null, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  // Committed on blur/Enter rather than on every keystroke - same reasoning as NumberFilterComponent.
  apply() {
    const amountFrom = this.fromControl.value;
    const amountTo = this.toControl.value;
    if (this.callBackFunction) {
      const hasValue = (v: number | null) => v !== null && v !== undefined && v !== ('' as any);
      this.callBackFunction(
        hasValue(amountFrom) || hasValue(amountTo)
          ? { amountFrom: hasValue(amountFrom) ? Number(amountFrom) : null, amountTo: hasValue(amountTo) ? Number(amountTo) : null }
          : null
      );
    }
  }
}
